import M_HANDLE_DATA from './components/handle_data/index.js'
/**
 * @description: 数据处理类
 */

class DataHandle {
    constructor (config){
        // // 上报队列
        // this.reportQueue = []
        // // 上报队列阈值
        // this.maxNum = config.maxNum || 10
    }

    /**
     * @description: 外部执行方法
     * @param {String} cmd 指令
     * @param {Object} main 外部实例
     * @param {Object} params 传入参数
     * @return {Object} 
     */    
    execute (cmd, main, params){
        // 总开关
        if (!main.mainSwitch) {
            return
        }
        switch (cmd) {
            case 'base': // 基础数据处理
                return M_HANDLE_DATA.handleBase(main, params)
            case 'pv': // pv数据处理
                return M_HANDLE_DATA.handlePV(main, params)
            case 'leave': // leave数据处理
                return M_HANDLE_DATA.handleLeave(main, params)
            case 'pageStay': // 页面停留数据处理
                return M_HANDLE_DATA.handleStay(main, params)
            case 'dom': // dom节点数据处理
                return M_HANDLE_DATA.handleDom(main, params)     
            default:
                break
        }
    }

    /**
     * @description: 获取上报队列
     * @return {Array}
     */
    // getReportQueue (){
    //     return this.reportQueue
    // }

    // /**
    //  * @description: 添加到上报队列
    //  * @return {Object}
    //  */    
    // addQueue (){                              
    //     // 当前队列数量小于设定阈值，直接加到队列
    //     if (this.reportQueue.length < this.maxNum) {
    //         this.reportQueue.push(this.getSingleData()) 
    //         return {
    //             retcode: 0,
    //             retmsg: ''
    //         }
    //     } else { // 当前队列数量达到阈值，提示要触发上报
    //         return {
    //             retcode: -1,
    //             retmsg: '上报队列已满'
    //         }
    //     }
    // }
}

export default new DataHandle()
